import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonHeader, IonToolbar, IonButton, IonTitle, IonContent, IonIcon } from '@ionic/angular/standalone';
import { ModalController, AlertController } from '@ionic/angular/standalone';
import { SexyModule } from "@qid/sexy";
import { SuperButtonComponent } from "@qid/super";
import { DocumentOcrResult, ScannedImage } from "../../../ocr";
import { User, UserService } from "../../../user";
import { ImageViewerService } from '../../../../components/image-viewer/image-viewer.service';

@Component({
  selector: 'app-name-correction',
  templateUrl: './name-correction.page.html',
  styleUrls: ['./name-correction.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SexyModule,
    SuperButtonComponent,
    IonHeader,
    IonToolbar,
    IonButton,
    IonTitle,
    IonContent,
    IonIcon
  ]
})
export class NameCorrectionPage implements OnInit {

  @Input() images: any[];
  @Input() userInput: string;
  @Input() documentImageScanResult: DocumentOcrResult;
  @Input() owner: User = null;

  selectedNameType: "system-generated" | "user-entered" = "system-generated";

  constructor(private modalController: ModalController,
    private userService: UserService,
    private alertController: AlertController,
    private imageViewerService: ImageViewerService
  ) {
  }

  ngOnInit() {

  }

  close() {
    this.modalController.dismiss();
  }

  // ponytail: await before dismiss; super-button owns the loader
  updateNameAsPerOcr = async () => {
    const name = this.selectedNameType === "user-entered"
      ? this.userInput
      : this.documentImageScanResult.extractedNameOnId;

    if (this.selectedNameType !== "user-entered") {
      this.documentImageScanResult.nameMatchPercentage = 100;
    }

    this.owner["name"] = name;
    await this.userService.updateUser(this.owner);
    return this.modalController.dismiss({ nameUpdated: true, name });
  };

  async viewIdImage(image: ScannedImage) {
    this.imageViewerService.open(image.imageUrl);
  }

  reUploadImages() {
    return this.modalController.dismiss({ reUpload: true });
  }

  async onNameSelected(nameType: "system-generated" | "user-entered") {
    if (nameType == "user-entered" && +this.documentImageScanResult.nameMatchPercentage < 50) {
      const alert = await this.alertController.create({
        header: 'Confirm Name',
        subHeader: `Set ${this.userInput} as the correct name?`,
        buttons: [
          {
            text: "No",
            role: "cancel"
          },
          {
            text: "Yes",
            handler: () => {
              this.selectedNameType = nameType;
              this.documentImageScanResult.nameMatchPercentage = 51;
            }
          }
        ]
      })
      await alert.present();
      return;
    }
    this.selectedNameType = nameType;
  }
}
